export const fetchShipmentData = async (payload) => {
    //configure api url
    const apiUrl = global.config.trackingServiceUrl;

    const response = await fetch(apiUrl + "/" + payload.airlineCode + "" + payload.trackingNumber, {
        method: 'GET',
        headers: {
            'Accept': '*/*',
        }
    });

    if (!response.ok && response.status !== 404) {
        throw new Error(response.statusText);
    }

    return await response.json();
};




// WEBPACK FOOTER //
// ./src/api/shipmentDataApi.js